function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCollectPaymenti = function SvgCollectPaymenti(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "m4.149 6.938 8.12-3.792a1.558 1.558 0 0 1 2.175 1.05l.162.68.622-.122a1.56 1.56 0 0 1 1.857 1.542l-.004.55h.93c.819 0 1.55.737 1.55 1.713v2.982a1.55 1.55 0 0 1 1.313 1.531v1.702a1.55 1.55 0 0 1-1.314 1.532v2.982c0 .976-.73 1.712-1.55 1.712H4.644c-.819 0-1.549-.736-1.549-1.712V8.558c0-.773.458-1.395 1.055-1.62m.51 1.306h-.005l-.045.02-.016.008-.016.019a.42.42 0 0 0-.086.268v10.73c0 .102.029.198.086.266.018.023.037.048.066.048H18.01c.029 0 .048-.025.066-.048a.4.4 0 0 0 .087-.267v-2.965h-1.616a2.401 2.401 0 0 1 0-4.8h1.616V8.56c0-.104-.03-.2-.087-.268-.018-.022-.037-.047-.066-.047zm14.818 4.828v1.702a.15.15 0 0 1-.151.153h-2.778a1.004 1.004 0 0 1 0-2.007h2.778c.083 0 .151.069.151.152m-3.793-6.225.005-.563a.16.16 0 0 0-.192-.16l-3.673.723zm-2.45-1.7-.149-.627a.16.16 0 0 0-.224-.108L9.875 5.806z"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCollectPaymenti);
export default ForwardRef;